import {
  FaHistory,
  FaHome,
  FaHandSparkles,
  FaUsers,
  FaPaste,
  FaCommentsDollar,
  FaRegClipboard,
  FaChartBar,
  FaUserCircle,
  FaRegArrowAltCircleRight,
  FaUserFriends,
  FaInfoCircle,
} from "react-icons/fa";
import { CiMedicalClipboard } from "react-icons/ci";
export const MENUITEMS_AGENT = [
  {
    path: "/dashboard",
    title: "s_dashboard",
    icon: FaHistory,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    title: "Property List",
    icon: FaHome,
    type: "sub",
    active: false,
    children: [
      {
        path: "/list_Sell_Property",
        title: "Sell Property List",
        type: "Sell Property List",
      },
      {
        path: "/list_Rent_Property",
        title: "Rent Property List",
        type: "Rent Property List",
      },
    ],
  },

  {
    title: "Required Property List",
    icon: FaHandSparkles,
    type: "sub",
    active: false,
    children: [
      {
        path: "/required-products/sell-list",
        title: "Buy Required Property",
        type: "Buy Required Property",
      },
      {
        path: "/required-products/rent-list",
        title: "Rent Required Property",
        type: "link",
      },
    ],
  },
  {
    title: "Contract List",
    icon: FaPaste,
    type: "sub",
    active: false,
    children: [
      {
        path: "/List_Sell_Invoices",
        title: "Sell Contracts",
        type: "Sell Contracts",
      },
      {
        path: "/List_Rent_Invoices",
        title: "Rent Contracts",
        type: "Rent Contracts",
      },
      {
        path: "/list_commerical_contract",
        title: "List of commercial contracts",
        type: "link",
      },
    ],
  },
  {
    title: "Loan",
    icon: FaInfoCircle,
    type: "sub",
    active: false,
    children: [
      {
        path: "/list-customer-owes",
        title: "Loan List",
        type: "link",
      },
      {
        path: "/list-Loan-Recipe",
        title: "List of loan receipts",
        type: "link",
      },
    ],
  },
  // {
  //   title: "Fast contracts",
  //   icon: CiMedicalClipboard,
  //   type: "sub",
  //   active: false,
  //   children: [
  //     {
  //       path: "/List_Sell_Invoices_fast",
  //       title: "Fast-selling contracts",
  //       type: "link",
  //     },
  //     {
  //       path: "/List_Rent_Invoices_fast",
  //       title: "Fast rental contracts",
  //       type: "link",
  //     },
  //   ],
  // },
  {
    title: "List of Bills",
    icon: FaRegClipboard,
    type: "sub",
    active: false,
    children: [
      {
        path: "/take_money_list",
        title: "list taking money",
        type: "list taking money",
      },
      {
        path: "/List_Paradan",
        title: "Payments List",
        type: "link",
      },
      {
        path: "/List_Scurety",
        title: "Security Bill List",
        type: "link",
      },
      {
        path: "/list_Anket_customert",
        title: "List of Seller Anket",
        type: "link",
      },
      // {
      //   path: "/List_Writers",
      //   title: "List of Scripts",
      //   type: "link",
      // },
    ],
  },
  {
    title: "Tenants_",
    icon: FaUsers,
    type: "sub",
    active: false,
    children: [
      {
        path: "/Tenant_Lists",
        title: "newest payment",
        type: "link",
      },
      {
        path: "/ontime-Tenant-Lists",
        title: "List of rental times",
        type: "link",
      },
      {
        path: "/expire-Tenant-Lists",
        title: "overdue rentals",
        type: "link",
      },
    ],
  },
  {
    title: "list of clients",
    icon: FaUserFriends,
    type: "sub",
    active: false,
    children: [
      {
        path: "/List_sellers_buyers",
        title: "list of clients",
        type: "link",
      },
    ],
  },
  {
    title: "Expenses",
    icon: FaCommentsDollar,
    type: "sub",
    active: false,
    children: [{ path: "/list_of_Masrufat", title: "Expenses", type: "link" }],
  },
  {
    title: "s_reports",
    icon: FaChartBar,
    type: "sub",
    active: false,
    children: [
      { path: "/property_report", title: "Property Report", type: "link" },
      {
        path: "/required_report",
        title: "Property Required Report",
        type: "link",
      },
    ],
  },
  // {
  //   title: "s_settings",
  //   icon: Settings,
  //   type: "sub",
  //   children: [
  //     { path: "/currency_price", title: "currency price", type: "link" },
  //   ],
  // },
  {
    title: "s_profile",
    icon: FaUserCircle,
    type: "sub",
    children: [
      { path: "/UserProfile_Agent", title: "s_profile", type: "link" },
      {
        path: "/settings/profile_Agent",
        title: "Update Profile",
        type: "link",
      },
    ],
  },
  {
    title: "s_logout",
    icon: FaRegArrowAltCircleRight,
    type: "sub",
    children: [{ path: "/", title: "s_logout", type: "logout_sub" }],
  },
];
